const FETCH_INSUR_COMPANIES_REQUEST = "FETCH_INSUR_COMPANIES_REQUEST";
const FETCH_INSUR_COMPANIES_SUCCESS = "FETCH_INSUR_COMPANIES_SUCCESS";
const FETCH_INSUR_COMPANIES_FAILURE = "FETCH_INSUR_COMPANIES_FAILURE";

export default {
  FETCH_INSUR_COMPANIES_REQUEST,
  FETCH_INSUR_COMPANIES_SUCCESS,
  FETCH_INSUR_COMPANIES_FAILURE,
};
